<template>
  <div class="ma-6">
    <div class="page-header-left">
      <h2 class="pr-3">Penjualan</h2>
      <v-spacer></v-spacer>
      <div class="listtotal">
        <v-card style="border: thin solid rgba(0,0,0,.12)" class="listtotal border_all mr-2" elevation="0">
          <v-sheet class="" color="green" width="50" height="60" elevation="0">
            <v-icon dark large class="icondash">shopping_cart</v-icon>
          </v-sheet>
          <div class="pl-2 pr-10">
            <div>Total Trx</div>
            <div>{{formatAngka(sumsell[0])}}</div>
          </div>
        </v-card>
        <v-card class="listtotal mr-2" style="border: thin solid rgba(0,0,0,.12)" elevation="0">
          <v-sheet class="" color="green" width="50" height="60" elevation="0">
            <v-icon dark large class="icondash">shopping_cart</v-icon>
          </v-sheet>
          <div class="pl-2 pr-10">
            <div>Amount Trx</div>
            <div>{{formatAngka(sumsell[1])}}</div>
          </div>
        </v-card>
        <v-card class="" style="border: thin solid rgba(0,0,0,.12)" elevation="0">
          <div class="pl-2 pr-2 align-content-center text-center">
            <v-switch
                style="position: relative!important;"
                v-model="statustoko"
                inset class="ml-2 mt-2"
                @change="changetokostatus"
                :label="`Status Trx: ${tokostatus?'Open':'Close'}`"
            >
              <template slot="label">
                  <v-chip
                      label
                      v-if="tokostatus"
                      color="green"
                      small
                      text-color="white">
                    {{statustokotext(tokostatus)}}
                  </v-chip>
                <v-chip
                    label
                    v-if="!tokostatus"
                    color="red"
                    small
                    text-color="white">
                  {{statustokotext(tokostatus)}}
                </v-chip>
              </template>
            </v-switch>
          </div>
        </v-card>
      </div>
    </div>
    <div class="mt-4 pr-0 pl-0 pt-2" style="border: thin solid rgba(0,0,0,.12)">
      <v-tabs  v-model="tab">
        <v-tab>Penjualan</v-tab>
        <v-tab>Produk</v-tab>
        <v-tab>HargaKhusus</v-tab>
        <v-tab>Setting</v-tab>
        <v-tab-item>
          <TrxJual/>
        </v-tab-item>
        <v-tab-item>
          <ProductJual/>
        </v-tab-item>
        <v-tab-item>
          <HargaKhusus/>
        </v-tab-item>
        <v-tab-item>
          <SettingApiJual/>
        </v-tab-item>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import TrxJual from '@/components/TrxJual'
import { mapActions, mapState } from 'vuex'
import Utils from '@/plugins/utils'
import ProductJual from '@/components/ProductJual'
import SettingApiJual from '@/components/SettingApiJual'
import HargaKhusus from '@/components/HargaKhusus'
export default {
  name: 'Penjualan',
  components: { HargaKhusus, SettingApiJual, ProductJual, TrxJual },
  data: () => ({
    tab: null,
    statustokoX: false
  }),
  mounted () {
    this.getSumsell()
    this.getStatustoko()
    this.getCategory()
    this.getBrands()
  },
  watch: {
    tokostatus: function (newVal, oldVal) {
      console.log('old:' + oldVal)
      console.log('new: ' + newVal)
    }
  },
  computed: {
    ...mapState('SellerStore', ['sumsell', 'tokostatus']),
    ...mapState('authentication', ['user']),
    statustoko: {
      get () {
        return this.tokostatus
      },
      set (val) {
        this.statustokoX = val
      }
    }
  },
  methods: {
    ...mapActions('ProductStore', ['getCategory', 'getBrands']),
    ...mapActions('SellerStore', ['getSumsell', 'updateStatusToko', 'getStatustoko', 'setlocalStatustoko']),
    formatAngka (val) {
      return Utils.formatAngka(val)
    },
    statustokotext (val) {
      if (val) {
        return 'Transaksi BUKA'
      } else {
        return 'Transaksi TUTUP'
      }
    },
    changetokostatus (val) {
      console.log(val)

      if (this.tokostatus && !val) {
        // tutup toko;
        this.$confirm('Yakin akan Tutup Transaksi ', { color: 'red', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
          if (res) {
            this.setlocalStatustoko(false)
            console.log('tutup toko')
            this.updateStatusToko(0)
          } else {
            this.setlocalStatustoko(true)
            this.statustoko = true
            console.log('cancel tutup toko')
          }
        })
      }
      if (!this.tokostatus && val) {
        // buka toko;
        this.$confirm('Yakin akan Buka Transaksi ', { color: 'green', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
          if (res) {
            this.setlocalStatustoko(true)
            console.log('buka toko')
            this.updateStatusToko(1)
          } else {
            this.setlocalStatustoko(false)
            this.statustoko = false
            console.log('cancel buka toko')
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.listtotal {
  display:flex;
  flex-wrap: wrap;
}
.icondash {
  margin-left: 6px;
  margin-top: 10px;
}
</style>
